import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';
import { IBreadcrumbProps } from '../../types/IBreadcrumb';

const Breadcrumbs = ({ links }: IBreadcrumbProps) => {
  const breadcumbLinks =
    links && links.length > 0
      ? links.map((val, index) => {
          const className = val.url
            ? 'breadcrumb-item notactive'
            : 'breadcrumb-item active';
          return (
            <Link key={index} className={className} to={{ pathname: val.url }}>
              {val.name}
            </Link>
          );
        })
      : [];

  return (
    <div className="breadcrumb" data-testid="breadcrumb-link">
      {breadcumbLinks}
    </div>
  );
};

export default Breadcrumbs;
